import React from "react";
import styled from "@emotion/styled";
import { COMPRESS_HEADER_BP, Hamburger } from "./Hamburger";
import { Link } from "../Link";

const Header = styled.header`
  width: 100%;
  position: absolute;
  z-index: 999;
`;

const Navigation = styled.nav<{
  isDark: boolean;
  colour?: string;
  offsetTop?: number;
}>`
  background-color: ${({ isDark, theme, colour }) =>
    isDark ? theme.colors.charcoal : colour};
  padding: 20px 20px 20px 20px;
  top: ${({ offsetTop }) => offsetTop || 0}px;

  @media ${COMPRESS_HEADER_BP} {
    padding: 20px 10%;
  }
`;

const logo =
  "data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 84 40'%3E%3Cg fill='%23222222'%3E%3Cpath d='M36.125 17.52c-.335-.143-.712.03-.676.492.367 4.608-1.583 7.537-3.215 7.537-.938 0-1.513-1.236-1.508-2.857.01-2.701 1.594-6.338 6.22-6.518a.49.49 0 0 0 .464-.436c.129-1.086-.752-2.186-3.17-2.186-2.987 0-5.989 2.859-7.072 6.28-.899 2.84-3.744 5.2-5.496 5.2-1.399 0-1.908-.96-1.908-2.5 0-2.46 1.012-6.497 3.301-6.492.52 0 1.097.172 1.498.681.133.169.258.242.37.242.375 0 .523-.68.523-1.132 0-1.373-1.335-2.228-3.125-2.22-3.839.011-6.628 4.343-6.684 8.266-.055 3.754 1.702 5.639 4.731 5.639 3.51 0 5.376-2.161 6.612-4.352.451 2.721 2.288 4.249 4.829 4.249 3.367 0 5.71-3.467 5.71-6.827 0-1.812-.435-2.656-1.404-3.067ZM57.174 16.377a8.456 8.456 0 0 1 1.191-.13.492.492 0 0 0 .47-.437c.133-1.098-.763-2.246-3.222-2.186-3.698.09-6.164 2.778-7.035 5.903-.75 2.7-3.035 6.432-4.33 6.432-.866 0-1.04-3.25-.915-6.547 3.42-4.98 6.1-11.973 6.1-16.629C49.433.946 48.578 0 47.278 0c-4.934 0-8.248 11.529-8.248 18.971 0 5.217 1.516 8.778 4.565 8.778 2.025 0 3.686-1.754 4.93-3.944.689 2.379 2.653 3.656 4.836 3.656 2.988 0 5.54-3.472 5.593-6.803.032-2.011-.693-3.597-1.78-4.28v-.002ZM47.576 3.198c.167 0 .223.168.223.521 0 1.636-1.42 6.887-4.22 12.121.62-6.1 2.657-12.642 3.997-12.642Zm5.947 22.422c-.953 0-1.488-1.151-1.481-2.79.008-2.322 1.175-5.325 4.417-6.283.853 4.822-1.25 9.073-2.937 9.073ZM14.173 24.044c-1.147.074-5.557.444-7.853.02-.384-.07-.714-.377-.741-.918-.043-.847.384-3.716.89-6.82 1.64-.052 4.74-.18 5.849-.435 1.14-.26 1.532-.575 1.915-1.182.223-.354.235-.85-.827-.872-1.62-.034-4.579-.014-6.525.017.342-2.022.673-3.945.89-5.275.15-.915.426-1.99-.152-2.777 1.781-.156 4.71-.42 6.715-.822 1.828-.365 2.765-1.102 2.768-1.788.002-.3-.376-.436-.652-.458-1.92-.16-10.187-.386-12.553.043-.405.073-.6.199-.736.612-.194.592.195 1.476.62 1.936-.878 3.751-2.173 12.062-2.774 16.687-.129.997-.225 1.466-.225 2.14 0 2.478 1.72 3.513 4.328 3.539 4.946 0 9.682-2.092 9.682-3.359 0-.238-.149-.317-.62-.286v-.002ZM82.995 21.933c-.15-.278-.335-.386-.5-.386a.424.424 0 0 0-.43.35c-.366 1.665-1.658 3.642-2.516 3.642-.417 0-.657-.505-.657-1.538 0-1.998 1.007-5.94 1.834-9.037a.485.485 0 0 0-.239-.554c-.612-.328-1.142-.506-1.606-.506-.805 0-1.443.616-1.894 1.872-.87 2.426-2.945 5.381-4.637 6.993-.015-1.534-.137-4.472-.551-6.729.153-.973-.192-2.476-2.372-2.476-6.349 0-9.38 5.366-9.38 9.176 0 2.425 1.258 3.887 2.954 3.887 1.95 0 4.678-2.012 6.167-5.157.053 1.204.069 2.488.036 3.899-5.863 5.294-8.678 9.563-8.746 12.278C60.42 39.19 61.36 40 62.786 40c3.468 0 8.354-6.144 9.416-14.88 1.413-1.39 2.69-2.789 3.86-4.407-.448 4.663.585 6.696 2.97 6.696 3.328 0 4.786-3.942 3.958-5.476h.005Zm-19.47 2.435c-.384 0-.481-.391-.481-.947 0-2.2 2.711-7.134 5.992-7.532-.45 4.223-4.225 8.477-5.51 8.48Zm-.075 12.198c-.283 0-.432-.156-.43-.413.008-1.207 3.047-4.816 5.675-7.573-1.145 3.933-3.932 7.986-5.245 7.986ZM79.815 12.097c1.028.245 1.995-.289 2.311-1.603.316-1.315-.348-2.24-1.333-2.476-1.028-.246-1.996.288-2.312 1.602-.316 1.315.349 2.24 1.334 2.477Z'/%3E%3C/g%3E%3C/svg%3E";

const lightLogo =
  "data:image/svg+xml,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 84 40'%3E%3Cg fill='%23fff'%3E%3Cpath d='M36.125 17.52c-.335-.143-.712.03-.676.492.367 4.608-1.583 7.537-3.215 7.537-.938 0-1.513-1.236-1.508-2.857.01-2.701 1.594-6.338 6.22-6.518a.49.49 0 0 0 .464-.436c.129-1.086-.752-2.186-3.17-2.186-2.987 0-5.989 2.859-7.072 6.28-.899 2.84-3.744 5.2-5.496 5.2-1.399 0-1.908-.96-1.908-2.5 0-2.46 1.012-6.497 3.301-6.492.52 0 1.097.172 1.498.681.133.169.258.242.37.242.375 0 .523-.68.523-1.132 0-1.373-1.335-2.228-3.125-2.22-3.839.011-6.628 4.343-6.684 8.266-.055 3.754 1.702 5.639 4.731 5.639 3.51 0 5.376-2.161 6.612-4.352.451 2.721 2.288 4.249 4.829 4.249 3.367 0 5.71-3.467 5.71-6.827 0-1.812-.435-2.656-1.404-3.067ZM57.174 16.377a8.456 8.456 0 0 1 1.191-.13.492.492 0 0 0 .47-.437c.133-1.098-.763-2.246-3.222-2.186-3.698.09-6.164 2.778-7.035 5.903-.75 2.7-3.035 6.432-4.33 6.432-.866 0-1.04-3.25-.915-6.547 3.42-4.98 6.1-11.973 6.1-16.629C49.433.946 48.578 0 47.278 0c-4.934 0-8.248 11.529-8.248 18.971 0 5.217 1.516 8.778 4.565 8.778 2.025 0 3.686-1.754 4.93-3.944.689 2.379 2.653 3.656 4.836 3.656 2.988 0 5.54-3.472 5.593-6.803.032-2.011-.693-3.597-1.78-4.28v-.002ZM47.576 3.198c.167 0 .223.168.223.521 0 1.636-1.42 6.887-4.22 12.121.62-6.1 2.657-12.642 3.997-12.642Zm5.947 22.422c-.953 0-1.488-1.151-1.481-2.79.008-2.322 1.175-5.325 4.417-6.283.853 4.822-1.25 9.073-2.937 9.073ZM14.173 24.044c-1.147.074-5.557.444-7.853.02-.384-.07-.714-.377-.741-.918-.043-.847.384-3.716.89-6.82 1.64-.052 4.74-.18 5.849-.435 1.14-.26 1.532-.575 1.915-1.182.223-.354.235-.85-.827-.872-1.62-.034-4.579-.014-6.525.017.342-2.022.673-3.945.89-5.275.15-.915.426-1.99-.152-2.777 1.781-.156 4.71-.42 6.715-.822 1.828-.365 2.765-1.102 2.768-1.788.002-.3-.376-.436-.652-.458-1.92-.16-10.187-.386-12.553.043-.405.073-.6.199-.736.612-.194.592.195 1.476.62 1.936-.878 3.751-2.173 12.062-2.774 16.687-.129.997-.225 1.466-.225 2.14 0 2.478 1.72 3.513 4.328 3.539 4.946 0 9.682-2.092 9.682-3.359 0-.238-.149-.317-.62-.286v-.002ZM82.995 21.933c-.15-.278-.335-.386-.5-.386a.424.424 0 0 0-.43.35c-.366 1.665-1.658 3.642-2.516 3.642-.417 0-.657-.505-.657-1.538 0-1.998 1.007-5.94 1.834-9.037a.485.485 0 0 0-.239-.554c-.612-.328-1.142-.506-1.606-.506-.805 0-1.443.616-1.894 1.872-.87 2.426-2.945 5.381-4.637 6.993-.015-1.534-.137-4.472-.551-6.729.153-.973-.192-2.476-2.372-2.476-6.349 0-9.38 5.366-9.38 9.176 0 2.425 1.258 3.887 2.954 3.887 1.95 0 4.678-2.012 6.167-5.157.053 1.204.069 2.488.036 3.899-5.863 5.294-8.678 9.563-8.746 12.278C60.42 39.19 61.36 40 62.786 40c3.468 0 8.354-6.144 9.416-14.88 1.413-1.39 2.69-2.789 3.86-4.407-.448 4.663.585 6.696 2.97 6.696 3.328 0 4.786-3.942 3.958-5.476h.005Zm-19.47 2.435c-.384 0-.481-.391-.481-.947 0-2.2 2.711-7.134 5.992-7.532-.45 4.223-4.225 8.477-5.51 8.48Zm-.075 12.198c-.283 0-.432-.156-.43-.413.008-1.207 3.047-4.816 5.675-7.573-1.145 3.933-3.932 7.986-5.245 7.986ZM79.815 12.097c1.028.245 1.995-.289 2.311-1.603.316-1.315-.348-2.24-1.333-2.476-1.028-.246-1.996.288-2.312 1.602-.316 1.315.349 2.24 1.334 2.477Z'/%3E%3C/g%3E%3C/svg%3E";

const Logo = styled(
  ({ isLight, ...props }: { isLight: boolean; href: string }) => (
    <Link {...props} />
  )
)`
  display: block;
  background-image: ${({ isLight }) =>
    isLight ? `url("${lightLogo}")` : `url("${logo}")`};
  background-repeat: no-repeat;
  background-size: 100%;
  height: 52px;
  position: relative;
  top: 10px;
  transition: opacity 0.3s;
  width: 100px;

  &:hover {
    opacity: 0.8;
  }

  @media ${({ theme }) => theme.bp.tabletUp} {
    margin: unset;
  }
`;

export type TopAppBarProps = {
  background?: "dark" | "default";
  isHamburgerVisible: boolean;
  isLight?: boolean;
  isLogoVisible: boolean;
  isOpen: boolean;
  navColour?: string;
  onClickHomeIcon: () => void;
  onClickMenuIcon: () => void;
  offsetTop?: number;
};

export function TopAppBar({
  background,
  isHamburgerVisible,
  isLight,
  isLogoVisible,
  isOpen,
  navColour,
  onClickHomeIcon,
  onClickMenuIcon,
  offsetTop,
}: TopAppBarProps) {
  const logoProps = {
    href: "/",
    onClick: (e: any) => {
      e.currentTarget.blur();
      onClickHomeIcon();
    },
    title: "Go to the home page",
  };

  if (!isLogoVisible && !isHamburgerVisible) {
    return <></>;
  }

  return (
    <Header>
      {isLogoVisible && (
        <Navigation
          isDark={background === "dark"}
          colour={navColour}
          offsetTop={offsetTop}
          aria-label="ecologi main navigation"
        >
          <Logo isLight={isLight ? isLight : false} {...logoProps} />
        </Navigation>
      )}
      {isHamburgerVisible && (
        <Hamburger
          onClickMenuIcon={onClickMenuIcon}
          isOpen={isOpen}
          offsetTop={offsetTop}
        />
      )}
    </Header>
  );
}
